<template>
  <Modal
    id="RegionImagesEdit"
    width="60%"
    :open="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
    :destroyOnClose="true"
  >
    <Row align="middle" justify="center">
      <Col span="18" class="content">
        <Row>
          <Col span="24">
            <Form
              ref="regionImagesForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                  <Col span="10">
                    <FormItem :label="$t('regionImages.field.id_reg')" name="idReg">
                        <!--关联表的下拉选择-->
                        <Select
                                v-model:value="form.idReg"
                                :placeholder="$t('regionImages.validate.required.id_reg')"
                                :dropdownStyle="{ zIndex: 9999999950 }"
                        >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['regionList']" :value="item['idReg']">{{ item['name'] }}</SelectOption>
                        </Select>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('regionImages.field.url')" ref="url" name="url">
                      <UploadImage
                        :url="form.url"
                         @new_image_url="(value) => {
                            this.$refs.url.clearValidate()
                            this.form.url = value
                         }"
                         ref="upload_url"
                      />
                  </FormItem>
                  </Col>
                  <!-- <Col span="10">
                    <FormItem :label="$t('regionImages.field.upload_time')" name="uploadTime">
                      <DatePicker show-time valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.uploadTime" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('regionImages.field.tenant_key')" name="tenantKey">
                                            <Input :placeholder="$t('regionImages.validate.required.tenant_key')"
                                                   v-model:value="form.tenantKey">
                                            </Input>
                  </FormItem>
                  </Col> -->
                <!--判断是否有子表，如果有则直接加入子表管理逻辑-->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
  Space,
  Card,
  Table,
  Popconfirm,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { RegionImagesAdd, RegionImagesEdit } from "@/api/regionImages";
import { RegionListAll } from "@/api/region"
import UploadImage from "@/components/Common/UploadImage"

import {GetUrl} from "@/api/common";

export default {
  name: "RegionImagesEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    UploadImage,
    Descriptions,
    DescriptionsItem,
    Space,
    Card,
    Table,
    Popconfirm,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idRegImg : undefined,
        idReg : undefined,
        url : undefined,
        uploadTime : undefined,
        tenantKey : undefined,
      },
      fileList: {
      },
      selectList: {
        regionList: [],
      },
      validateRules: {
        idRegImg: [
          {
            required: true,
            message: this.$t("regionImages.validate.required.id_reg_img"),
            trigger: "change",
            type: "number",
          },
        ],
        idReg: [
          {
            required: true,
            message: this.$t("regionImages.validate.required.id_reg"),
            trigger: "change",
            type: "number",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("regionImages.validate.required.url"),
            trigger: "change",
          },
        ],
        uploadTime: [
          {
            required: true,
            message: this.$t("regionImages.validate.required.upload_time"),
            trigger: "change",
          },
        ],
        tenantKey: [
          {
            required: true,
            message: this.$t("regionImages.validate.required.tenant_key"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  watch: {
      "visible": {
          deep: true,
          handler: function (newValue, oldValue) {
              if (!newValue) {
                  this.$emit("updateList");
              }
          }
      }
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getRegionList();
      if (this.$refs.upload_url) {
          this.$refs.upload_url.change_url("")
      }
      this.visible = true;
    },
    editShow(obj) {
      this._resetData();
      // if (this.$refs.upload_url) {
      //   this.$refs.upload_url.change_url("")
      // }
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getRegionList();

      this.visible = true;
    },
    submit() {
      this.$refs["regionImagesForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new RegionImagesAdd();
              break;
            case "edit":
              console.log("edit");
              api = new RegionImagesEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 === parseInt(response.data.code)) {
              message.success(this.$t("succeedMsg.0"));
              this.$emit("updateList",response.data.data);
              this.visible = false;
            } else {
              if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
            }
          });
        })
        .catch(() => {
        });
    },
    getRegionList() {
      const api = new RegionListAll();
      api.get().then((response) => {
        if (0 === parseInt(response.data.code)) {
            this.selectList.regionList = response.data.data;
        } else {
            if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idRegImg : undefined,
        idReg : undefined,
        url : undefined,
        uploadTime : undefined,
        tenantKey : undefined,
      };
    },
  },
};
</script>

<style lang="less">
</style>
